import React from 'react';
import {Button, Card, Col, Form, message, Modal, Row,Tooltip,Icon} from 'antd';
import {fetchEvt} from "../../redux/actions/evt";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {updateEventPosters, updateEventQrcodeLogo} from "../../services/evt";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import QRCode from "../../components/qr-code/QRCode";
import Logo2 from "../../style/imgs/logo2.png"
import CkUpload from "../../components/CkUpload";
import canvasToImage from 'canvas-to-image';
import {mobile_url_domin} from "../../utils/config";


const mapStateToPorps = state => {
    const cmEnums = state.cmEnums;
    return {cmEnums};
};
const mapDispatchToProps = dispatch => ({
    fetchEvt: bindActionCreators(fetchEvt, dispatch),
});


class EvtViewQrcodeForm extends React.Component {
    constructor(props) {
        super(props);
        this.mounted = false;
        this.state = {
            qrcodeSize:[{px:258,side:8,dis:0.5},{px:344,side:12,dis:0.8},{px:430,side:15,dis:1.0},{px:860,side:30,dis:1.5},{px:1280,side:50,dis:2.5}],
            qrcodeModal:{
                title:null,
                refName:null,
                value:null
            },
            qrcodeDownload:false,
            formLoading: false
        }
    }

    componentDidMount() {
        this.mounted = true;
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    save = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
            if (!error) {
                this.changeFormLoading(true);
                const that = this;
                updateEventQrcodeLogo(Object.assign({eventId: this.props.evt.header.id}, values)).then(res => {
                    if (res.code == 200) {
                        message.info("更新成功!");
                        that.props.editableChange(this.props.editableStatePropName, false, true)
                    } else {
                        message.error(res.msg,6);
                    }
                }).catch(err => {
                    message.warn("访问异常");
                }).finally(() => {
                    that.changeFormLoading(false)
                })
            } else {
                console.log('error', error, values);
            }
        });
    }

    changeFormLoading = (loading) => {
        if (this.mounted) {
            this.setState({
                formLoading: loading
            })
        }
    }

    handleCancel = () => {
        this.changeFormLoading(false)
        this.props.editableChange(this.props.editableStatePropName, false)
    }

    downloadQR = (QRRef, fileName) => {
        canvasToImage(QRRef, {
            name: fileName,
            type: 'png',
            quality: 1
        });
    }
    showQrcodeDownload = (ref)=>{
        const {evt} = this.props;
        let _obj={};
        if(ref == 'event-qr-canvas'){
            _obj={
                title:'活动二维码',
                refName:ref,
                value:`${mobile_url_domin}/mobile/event/${evt.header.id}?hostUserId=${localStorage.getItem('userId')}`
            }
        } else if(ref == 'register-qr-canvas'){
            _obj={
                title:'报名二维码',
                refName:ref,
                value:`${mobile_url_domin}/mobile/signup/${evt.header.id}?hostUserId=${localStorage.getItem('userId')}`
            }
        }else {
            _obj={
                title:'找回凭证二维码',
                refName:ref,
                value:`${mobile_url_domin}/mobile/findvoucher?eventId=${evt.header.id}&hostUserId=${localStorage.getItem('userId')}`
            }
        }

        this.setState({
            qrcodeModal:_obj,
        },()=>{
            this.setState({
                qrcodeDownload:true,
            })
        })
    }
    handQrcodeDownload = ()=>{
        this.setState({
            qrcodeDownload:false,
        })
    }

    render() {
        const evt = this.props.evt;

        const {getFieldDecorator, getFieldValue, getFieldError} = this.props.form;


        const formItemLayout = {
            labelCol: {
                xs: {span: 6},
                sm: {span: 6},
            },
            wrapperCol: {
                xs: {span: 18},
                sm: {span: 18},
            },
        };


        return (
            <div>
                <Row gutter={16}>
                    <Col span={8}>
                        <Card title="活动二维码" className="qrcode-card">
                            <div className="qrcode-card-contain">
                                <div className="qrcode-card-qr">
                                    <QRCode
                                        value={`${mobile_url_domin}/mobile/share/event/${evt.header.id}?hostUserId=${localStorage.getItem('userId')}`}
                                        size={100}
                                        refName="event-qr-canvas"
                                        logoWidth={23}
                                        logoHeight={23}
                                        logo={evt.header.customQrcodeLogo ? evt.header.customQrcodeLogo : "https://img.qdj8.cn/505e1820bb683015744878f05bf1248c090dfddd.jpg"}/>
                                </div>
                                <div className="qrcode-card-des">
                                    <div> 参与者可通过扫描此二维码查看活动详情，并进行活动报名</div>
                                    <div className="qrcode-tools">
                                        <CopyToClipboard text={`${mobile_url_domin}/mobile/share/event/${evt.header.id}?hostUserId=${localStorage.getItem('userId')}`} onCopy={() => message.success("已复制!")}>
                                            <a href="#">复制链接</a>
                                        </CopyToClipboard>
                                        <a href="#" onClick={()=>this.showQrcodeDownload('event-qr-canvas')}>下载</a>
                                    </div>

                                </div>
                            </div>
                        </Card>
                    </Col>
                    <Col span={8}>
                        <Card title="报名二维码" className="qrcode-card">
                            <div className="qrcode-card-contain">
                                <div className="qrcode-card-qr">
                                    <QRCode
                                        value={`${mobile_url_domin}/mobile/signup/${evt.header.id}?hostUserId=${localStorage.getItem('userId')}`}
                                        size={100}
                                        refName="register-qr-canvas"
                                        logoWidth={23}
                                        logoHeight={23}
                                        logo={evt.header.customQrcodeLogo ? evt.header.customQrcodeLogo : "https://img.qdj8.cn/658a0f0f696a1818e7fb303c6eec45c5b8022327.jpg"}/>
                                </div>
                                <div className="qrcode-card-des">
                                    <div>参与者扫描此二维码可以不查看活动详情，<span className="mdc-text-red">直接报名活动</span>，可以和其他三方邀请函/网页结合，最后一页放入此链接/二维码</div>
                                    <div className="qrcode-tools">
                                        <CopyToClipboard text={`${mobile_url_domin}/mobile/signup/${evt.header.id}?hostUserId=${localStorage.getItem('userId')}`} onCopy={() => message.success("已复制!")}>
                                            <a href="#">复制链接</a>
                                        </CopyToClipboard>
                                        <a href="#" onClick={()=>this.showQrcodeDownload('register-qr-canvas')}>下载</a>
                                    </div>

                                </div>
                            </div>

                        </Card>
                    </Col>
                    <Col span={8}>
                        <Card title="找回报名信息" className="qrcode-card">
                            <div className="qrcode-card-contain">
                                <div className="qrcode-card-qr">
                                    <QRCode
                                        value={`${mobile_url_domin}/mobile/findvoucher?eventId=${evt.header.id}`}
                                        size={100}
                                        refName="register-cert-qr-canvas"
                                        logoWidth={23}
                                        logoHeight={23}
                                        logo={evt.header.customQrcodeLogo ? evt.header.customQrcodeLogo : "https://img.qdj8.cn/c366aee8a0733cc2de96be3ddebe3e65182df096.jpg"}/>
                                </div>
                                <div className="qrcode-card-des">

                                    <div>已经报名的参与者可通过扫描此二维码<span className="mdc-text-red">找回报名信息，签到二维码，查看活动详情，日程等</span>
                                    </div>
                                    <div className="qrcode-tools">
                                        <CopyToClipboard text={`${mobile_url_domin}/mobile/findvoucher?eventId=${evt.header.id}&hostUserId=${localStorage.getItem('userId')}`} onCopy={() => message.success("已复制!")}>
                                            <a href="#">复制链接</a>
                                        </CopyToClipboard>
                                        <a href="#" onClick={()=>this.showQrcodeDownload('register-cert-qr-canvas')}>下载</a>
                                    </div>

                                </div>
                            </div>
                        </Card>
                    </Col>
                </Row>

                <Modal
                    visible={this.props.editable}
                    title="更换二维码LOGO"
                    width="650px"
                    maskClosable={false}
                    onCancel={this.handleCancel}
                    footer={[
                        <Button key="back" onClick={this.handleCancel}>
                            放弃
                        </Button>,
                        <Button key="submit" type="primary" loading={this.state.formLoading} onClick={this.save}>
                            保存
                        </Button>,
                    ]}
                >
                    <Form.Item
                        {...formItemLayout}
                        label={(
                            <span>
                                二维码LOGO
                            </span>
                        )}
                        extra="必须上传宽高比为1:1的图片(如:100x100)，最大200x200像素!"
                    >

                        {getFieldDecorator('customQrcodeLogo', {
                            initialValue: evt.header.customQrcodeLogo == 'removed' ? null : evt.header.customQrcodeLogo,
                            rules: [
                                {required: false, message: '二维码LOGO'}
                            ],
                            getValueFromEvent: (fileUrlObj) => {
                                return fileUrlObj.url;
                            }
                        })(
                            <CkUpload
                                width={100}
                                height={100}
                            />
                        )}
                    </Form.Item>

                </Modal>
                <Modal
                    visible={this.state.qrcodeDownload}
                    title={<div>
                        {this.state.qrcodeModal.title}
                        <p style={{fontSize:12,color:'#959595'}}>若无法下载，请使用最新版谷歌Chrome浏览器</p>
                    </div>}
                    // width="650px"
                    maskClosable={false}
                    onCancel={this.handQrcodeDownload}
                    footer={null}
                >
                   <div>
                       {this.state.qrcodeDownload ? this.state.qrcodeSize.map((obj,index)=>{
                           return <div key={index} style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'5px 30px'}}>
                               <div>
                                   <div style={{display:'none'}}>
                                       <QRCode
                                           value={this.state.qrcodeModal.value}
                                           size={obj.px}
                                           refName={`${this.state.qrcodeModal.refName}${index}`}
                                           logoWidth={obj.px/6}
                                           logoHeight={obj.px/6}
                                           logo={evt.header.customQrcodeLogo ? evt.header.customQrcodeLogo : Logo2}/>
                                   </div>
                                   <div style={{width:82,textAlign:'center'}}>
                                       <Icon type='qrcode' style={{fontSize:40}}/>
                                       <div style={{fontSize:12,color:'#999'}}>{obj.px}x{obj.px}像素</div>
                                   </div>
                               </div>
                               <div>边长{obj.side}cm</div>
                               <div>扫码距离{obj.dis}m</div>
                               <a href="#" onClick={this.downloadQR.bind(this, `${this.state.qrcodeModal.refName}${index}`, `[${evt.header.name}]-${this.state.qrcodeModal.title}_${obj.px}`)}>下载</a>
                           </div>
                       }) : ''}
                   </div>

                </Modal>
            </div>
        )
    }
}


EvtViewQrcodeForm.contextTypes = {}

EvtViewQrcodeForm.defaultProps = {
    evt: {},
    editable: false,
    editableStatePropName: "qrcodeEditable",
    editableChange: (editable, dataChanged = false) => null,
}

EvtViewQrcodeForm.propTypes = {}


export default connect(mapStateToPorps, mapDispatchToProps)(Form.create()(EvtViewQrcodeForm));


// WEBPACK FOOTER //
// ./src/containers/evt/EvtViewQrcodeForm.jsx